import { PlessViewUtilsSub } from './../../../commons/kymw00/pless-view-utils-sub.service';
import { KYMW1102SearchResultModel } from './vo/kymw1102-search-result.model';
import { KYMW0300OutputModel } from '../../../commons/kymw03/kymw0300/vo/kymw0300-output.model';
import { KYMW1102Component } from './kymw1102.component';

/**
 * 新規取扱商品画面の値を管理するクラス
 *
 * @export KYMW1102Model
 * @class KYMW1102Model
 */
export class KYMW1102Model {

  kymw1102Component: KYMW1102Component;

  /**
   * 検索結果一覧
   */

  public selectInfoList: Array<any> = new Array<any>();

  /**
   * 供給計画
   */

  public supplyPlan: string = <string>'';


  public selectOutput: boolean = <boolean>false;

  public kymw1102VO: KYMW1102SearchResultModel = new KYMW1102SearchResultModel();
  public kymw1102List: Array<KYMW1102SearchResultModel> = new Array<KYMW1102SearchResultModel>();
  private kymw0300: KYMW0300OutputModel = new KYMW0300OutputModel();

  // バインド用変数
  public classCode: string = <string>'';
  public buyerCode: string = <string>'';
  public admit: boolean = <boolean>true;
  public year: string = <string>'';
  public month: string = <string>'';
  public kai: string = <string>'';
  public chargeParson: string = <string>'';
  public kikakumonth: string = <string>'';
  public kikakukai: string = <string>'';
  public pointplan: string = <string>'';

  // ラベルのバインド
  public pcode: string = <string>'';
  public itemcode: string = <string>'';
  public jancode: string = <string>'';
  public goodsname: string = <string>'';
  public standardsname: string = <string>'';
  public supplyprice: string = <string>'';
  public brandkbn: string = <string>'';
  public hozonkbn: string = <string>'';
  public peacewidth: string = <string>'';
  public peaceheight: string = <string>'';
  public peacelength: string = <string>'';
  public casewidth: string = <string>'';
  public caseheight: string = <string>'';
  public caselength: string = <string>'';

  /**
   * ファイル名
   */
  public fileName: string;

  /**
   *
   * @param serverData ユーザーリストのサーバ取得データ
   */
  public setSelectInfoData(serverData: any): void {
    if (!PlessViewUtilsSub.isEmptyArray(this.selectInfoList)) {
      this.selectInfoList = [];
    }

    if (!PlessViewUtilsSub.isEmptyArray(this.kymw1102List)) {
      this.kymw1102List = [];
    }

    if (serverData != null) {
      if (serverData instanceof Array) {
        const tempList = new Array<any>();
        // SelectInfoDataタグの中に入っているデータ分処理を行う
        for (let i: number = <number>0; i < serverData.length; i++) {
          // 新規取扱商品VOを生成し、Listに追加する
          tempList.push(this.createSelectInfoVO(serverData[i]));
        }
        this.selectInfoList = tempList;
      } else {
        // 新規取扱商品VOを生成し、Listに追加する
        this.selectInfoList = [this.createSelectInfoVO(serverData)];
      }
    }
  }

  /**
   *
   * @param serverData ユーザーリストのサーバ取得データ
   */
  public setCalcSupplyPlan(serverData: any): void {
    this.supplyPlan = serverData.SupplyPlan;
  }

  /**
   *
   * @param serverData ユーザーリストのサーバ取得データ
   */
  public isCheckRow(): Array<any> {
    return this.kymw1102List;
  }

  public setCalcData(pointPlan: string, supplyPrice: string): KYMW1102SearchResultModel {
    this.kymw1102VO.pointPlan = pointPlan;
    this.kymw1102VO.supplyPrice = supplyPrice;

    return this.kymw1102VO;
  }

  /**
   * 選択行のデータを返却する
   *
   */
  public returnSelectInfoIndi(index: number): KYMW1102SearchResultModel {
    const arr: KYMW1102SearchResultModel = this.kymw1102List[index];
    return arr;
  }

  /**
   * 画面で入力された企画月と企画回を保存する
   *
   */
  public setProjectInfo(index: number, month: string, kai: string, pointPlan: string, supplyPlan: string): void {
    this.kymw1102List[index].proMonth = month;
    this.kymw1102List[index].proKai = kai;
    this.kymw1102List[index].pointPlan = pointPlan;
    this.kymw1102List[index].supplyPlan = supplyPlan;
  }

  /**
   * 生協別価格表示用検索条件保存
   *
   */
  public setSelectedCoop(data: Array<any>, val: boolean): void {
    if (val) {
      this.kymw0300.coopCodeList = null;
    } else {
      this.kymw0300.coopCodeList = data;
    }
  }

  /**
   * ファイル名を更新する
   *
   * @param serverData ファイル名のサーバ取得データ
   */
  public updateFileName(serverData: any): void {
    this.fileName = serverData.FileName;
  }

  /**
   * サーバデータを検索結果VOに設定
   *
   */
  public createSelectInfoVO(selectInfo: any): KYMW1102SearchResultModel {
    // VOの生成
    const tempVO: any = new KYMW1102SearchResultModel();
    const viewVO: any = new KYMW1102SearchResultModel();
    const indiVO: any = new KYMW1102SearchResultModel();

    tempVO.PCode = selectInfo.PCode;
    tempVO.ClassDivNum = selectInfo.ClassDivNum;
    tempVO.ClassCode = selectInfo.ClassCode;
    tempVO.MiddleClassCode = selectInfo.MiddleClassCode;
    tempVO.SmallClassCode = selectInfo.SmallClassCode;
    tempVO.GuideGoodsName = selectInfo.GuideGoodsName;
    tempVO.GuideStandardName = selectInfo.GuideStandardName;
    tempVO.ConsumeTerm = selectInfo.ConsumeTerm;
    tempVO.ConsymeByDate = selectInfo.ConsymeByDate;
    tempVO.SetDiv = selectInfo.SetDiv;
    tempVO.LongKeepDiv = selectInfo.LongKeepDiv;
    tempVO.AssortTempDiv = selectInfo.AssortTempDiv;
    tempVO.ItemCode = selectInfo.ItemCode;
    tempVO.JanCode = selectInfo.JanCode;
    tempVO.BrandType = selectInfo.BrandType;
    tempVO.OrderClientCode = selectInfo.OrderClientCode;
    tempVO.MakerName = selectInfo.MakerName;
    tempVO.EbaseSpecCode = selectInfo.EbaseSpecCode;
    tempVO.PeaceSizeLength = selectInfo.PeaceSizeLength;
    tempVO.PeaceSizeWidth = selectInfo.PeaceSizeWidth;
    tempVO.PeaceSizeHeight = selectInfo.PeaceSizeHeight;
    tempVO.CaseSizeLength = selectInfo.CaseSizeLength;
    tempVO.CaseSizeWidth = selectInfo.CaseSizeWidth;
    tempVO.CaseSizeHeight = selectInfo.CaseSizeHeight;
    tempVO.RegistCatalogRound = selectInfo.RegistCatalogRound;
    tempVO.ClassNameKanji = selectInfo.ClassNameKanji;
    tempVO.MiddleClassNameKanji = selectInfo.MiddleClassNameKanji;
    tempVO.SmallClassNameKanji = selectInfo.SmallClassNameKanji;
    // 消費税区分
    tempVO.ConsumeTaxDiv = selectInfo.ConsumeTaxDiv;
    // 消費税率
    tempVO.ConsumeTaxRate = selectInfo.ConsumeTaxRate;

    tempVO.BrandTypeName = selectInfo.BrandTypeName;
    tempVO.AssortTempDivName = selectInfo.AssortTempDivName;
    tempVO.SetDivName = selectInfo.SetDivName;
    tempVO.LongkeepDivName = selectInfo.LongkeepDivName;
    tempVO.OrderClientName = selectInfo.OrderClientName;

    tempVO.proMonth = '';
    tempVO.proKai = '';
    tempVO.pointPlan = '';
    tempVO.supplyPlan = '';

    // 生協コード
    // どれも選択されていない（全て選択）：0（さいたまから生協コードが小さい順に値を取得）
    // 選択されている：1
    // 選択されていない：2
    let saitamaFlg: number = <number>0;
    let ibarakiFlg: number = <number>0;
    let tochigiFlg: number = <number>0;
    let gunmaFlg: number = <number>0;
    let chibaFlg: number = <number>0;
    let tokyoFlg: number = <number>0;
    let niigataFlg: number = <number>0;
    let naganoFlg: number = <number>0;

    if (!PlessViewUtilsSub.isEmptyArray(this.kymw0300.coopCodeList)) {
      saitamaFlg = 2;
      ibarakiFlg = 2;
      tochigiFlg = 2;
      gunmaFlg = 2;
      chibaFlg = 2;
      tokyoFlg = 2;
      niigataFlg = 2;
      naganoFlg = 2;

      for (const coop in this.kymw0300.coopCodeList) {
        if (this.kymw1102Component.kymw00Model.COOP_CODE_SA === coop) {
          saitamaFlg = 1;
        } else if (this.kymw1102Component.kymw00Model.COOP_CODE_IB === coop) {
          ibarakiFlg = 1;
        } else if (this.kymw1102Component.kymw00Model.COOP_CODE_TO === coop) {
          tochigiFlg = 1;
        } else if (this.kymw1102Component.kymw00Model.COOP_CODE_GU === coop) {
          gunmaFlg = 1;
        } else if (this.kymw1102Component.kymw00Model.COOP_CODE_TI === coop) {
          chibaFlg = 1;
        } else if (this.kymw1102Component.kymw00Model.COOP_CODE_TK === coop) {
          tokyoFlg = 1;
        } else if (this.kymw1102Component.kymw00Model.COOP_CODE_NA === coop) {
          naganoFlg = 1;
        } else if (this.kymw1102Component.kymw00Model.COOP_CODE_NI === coop) {
          niigataFlg = 1;
        }
      }
    }

    // 全生協価格なしの場合のため、初期化
    tempVO.SupplyPriceStandard = '0';
    tempVO.SupplyPriceSpecial1 = '0';
    tempVO.SupplyPriceSpecial2 = '0';
    tempVO.SupplyTaxWithoutStd = '0';
    tempVO.SupplyTaxWithoutSpc1 = '0';
    tempVO.SupplyTaxWithoutSpc2 = '0';
    tempVO.CostPriceStandard = '0';
    tempVO.CostPriceSpecial1 = '0';
    tempVO.CostPriceSpecial2 = '0';


    if (saitamaFlg !== 2 && !PlessViewUtilsSub.isEmpty(selectInfo.SupplyPriceStandard_1) &&
      0 !== selectInfo.SupplyPriceStandard_1) {
      tempVO.SupplyPriceStandard = selectInfo.SupplyPriceStandard_1;
      tempVO.SupplyPriceSpecial1 = selectInfo.SupplyPriceSpecial1_1;
      tempVO.SupplyPriceSpecial2 = selectInfo.SupplyPriceSpecial2_1;
      tempVO.SupplyTaxWithoutStd = selectInfo.SupplyTaxWithoutStd_1;
      tempVO.SupplyTaxWithoutSpc1 = selectInfo.SupplyTaxWithoutSpc1_1;
      tempVO.SupplyTaxWithoutSpc2 = selectInfo.SupplyTaxWithoutSpc2_1;
      tempVO.CostPriceStandard = selectInfo.CostPriceStandard_1;
      tempVO.CostPriceSpecial1 = selectInfo.CostPriceSpecial1_1;
      tempVO.CostPriceSpecial2 = selectInfo.CostPriceSpecial2_1;
    } else if (ibarakiFlg !== 2 && !PlessViewUtilsSub.isEmpty(selectInfo.SupplyPriceStandard_2) &&
      0 !== selectInfo.SupplyPriceStandard_2) {
      tempVO.SupplyPriceStandard = selectInfo.SupplyPriceStandard_2;
      tempVO.SupplyPriceSpecial1 = selectInfo.SupplyPriceSpecial1_2;
      tempVO.SupplyPriceSpecial2 = selectInfo.SupplyPriceSpecial2_2;
      tempVO.SupplyTaxWithoutStd = selectInfo.SupplyTaxWithoutStd_2;
      tempVO.SupplyTaxWithoutSpc1 = selectInfo.SupplyTaxWithoutSpc1_2;
      tempVO.SupplyTaxWithoutSpc2 = selectInfo.SupplyTaxWithoutSpc2_2;
      tempVO.CostPriceStandard = selectInfo.CostPriceStandard_2;
      tempVO.CostPriceSpecial1 = selectInfo.CostPriceSpecial1_2;
      tempVO.CostPriceSpecial2 = selectInfo.CostPriceSpecial2_2;
    } else if (tochigiFlg !== 2 && !PlessViewUtilsSub.isEmpty(selectInfo.SupplyPriceStandard_3) &&
      0 !== selectInfo.SupplyPriceStandard_3) {
      tempVO.SupplyPriceStandard = selectInfo.SupplyPriceStandard_3;
      tempVO.SupplyPriceSpecial1 = selectInfo.SupplyPriceSpecial1_3;
      tempVO.SupplyPriceSpecial2 = selectInfo.SupplyPriceSpecial2_3;
      tempVO.SupplyTaxWithoutStd = selectInfo.SupplyTaxWithoutStd_3;
      tempVO.SupplyTaxWithoutSpc1 = selectInfo.SupplyTaxWithoutSpc1_3;
      tempVO.SupplyTaxWithoutSpc2 = selectInfo.SupplyTaxWithoutSpc2_3;
      tempVO.CostPriceStandard = selectInfo.CostPriceStandard_3;
      tempVO.CostPriceSpecial1 = selectInfo.CostPriceSpecial1_3;
      tempVO.CostPriceSpecial2 = selectInfo.CostPriceSpecial2_3;
    } else if (gunmaFlg !== 2 && !PlessViewUtilsSub.isEmpty(selectInfo.SupplyPriceStandard_4) &&
      0 !== selectInfo.SupplyPriceStandard_4) {
      tempVO.SupplyPriceStandard = selectInfo.SupplyPriceStandard_4;
      tempVO.SupplyPriceSpecial1 = selectInfo.SupplyPriceSpecial1_4;
      tempVO.SupplyPriceSpecial2 = selectInfo.SupplyPriceSpecial2_4;
      tempVO.SupplyTaxWithoutStd = selectInfo.SupplyTaxWithoutStd_4;
      tempVO.SupplyTaxWithoutSpc1 = selectInfo.SupplyTaxWithoutSpc1_4;
      tempVO.SupplyTaxWithoutSpc2 = selectInfo.SupplyTaxWithoutSpc2_4;
      tempVO.CostPriceStandard = selectInfo.CostPriceStandard_4;
      tempVO.CostPriceSpecial1 = selectInfo.CostPriceSpecial1_4;
      tempVO.CostPriceSpecial2 = selectInfo.CostPriceSpecial2_4;
    } else if (chibaFlg !== 2 && !PlessViewUtilsSub.isEmpty(selectInfo.SupplyPriceStandard_5) &&
      0 !== selectInfo.SupplyPriceStandard_5) {
      tempVO.SupplyPriceStandard = selectInfo.SupplyPriceStandard_5;
      tempVO.SupplyPriceSpecial1 = selectInfo.SupplyPriceSpecial1_5;
      tempVO.SupplyPriceSpecial2 = selectInfo.SupplyPriceSpecial2_5;
      tempVO.SupplyTaxWithoutStd = selectInfo.SupplyTaxWithoutStd_5;
      tempVO.SupplyTaxWithoutSpc1 = selectInfo.SupplyTaxWithoutSpc1_5;
      tempVO.SupplyTaxWithoutSpc2 = selectInfo.SupplyTaxWithoutSpc2_5;
      tempVO.CostPriceStandard = selectInfo.CostPriceStandard_5;
      tempVO.CostPriceSpecial1 = selectInfo.CostPriceSpecial1_5;
      tempVO.CostPriceSpecial2 = selectInfo.CostPriceSpecial2_5;
    } else if (tokyoFlg !== 2 && !PlessViewUtilsSub.isEmpty(selectInfo.SupplyPriceStandard_6) &&
      0 !== selectInfo.SupplyPriceStandard_6) {
      tempVO.SupplyPriceStandard = selectInfo.SupplyPriceStandard_6;
      tempVO.SupplyPriceSpecial1 = selectInfo.SupplyPriceSpecial1_6;
      tempVO.SupplyPriceSpecial2 = selectInfo.SupplyPriceSpecial2_6;
      tempVO.SupplyTaxWithoutStd = selectInfo.SupplyTaxWithoutStd_6;
      tempVO.SupplyTaxWithoutSpc1 = selectInfo.SupplyTaxWithoutSpc1_6;
      tempVO.SupplyTaxWithoutSpc2 = selectInfo.SupplyTaxWithoutSpc2_6;
      tempVO.CostPriceStandard = selectInfo.CostPriceStandard_6;
      tempVO.CostPriceSpecial1 = selectInfo.CostPriceSpecial1_6;
      tempVO.CostPriceSpecial2 = selectInfo.CostPriceSpecial2_6;
    } else if (niigataFlg !== 2 && !PlessViewUtilsSub.isEmpty(selectInfo.SupplyPriceStandard_7) &&
      0 !== selectInfo.SupplyPriceStandard_7) {
      tempVO.SupplyPriceStandard = selectInfo.SupplyPriceStandard_7;
      tempVO.SupplyPriceSpecial1 = selectInfo.SupplyPriceSpecial1_7;
      tempVO.SupplyPriceSpecial2 = selectInfo.SupplyPriceSpecial2_7;
      tempVO.SupplyTaxWithoutStd = selectInfo.SupplyTaxWithoutStd_7;
      tempVO.SupplyTaxWithoutSpc1 = selectInfo.SupplyTaxWithoutSpc1_7;
      tempVO.SupplyTaxWithoutSpc2 = selectInfo.SupplyTaxWithoutSpc2_7;
      tempVO.CostPriceStandard = selectInfo.CostPriceStandard_7;
      tempVO.CostPriceSpecial1 = selectInfo.CostPriceSpecial1_7;
      tempVO.CostPriceSpecial2 = selectInfo.CostPriceSpecial2_7;
    } else if (naganoFlg !== 2 && !PlessViewUtilsSub.isEmpty(selectInfo.SupplyPriceStandard_8) &&
      0 !== selectInfo.SupplyPriceStandard_8) {
      tempVO.SupplyPriceStandard = selectInfo.SupplyPriceStandard_8;
      tempVO.SupplyPriceSpecial1 = selectInfo.SupplyPriceSpecial1_8;
      tempVO.SupplyPriceSpecial2 = selectInfo.SupplyPriceSpecial2_8;
      tempVO.SupplyTaxWithoutStd = selectInfo.SupplyTaxWithoutStd_8;
      tempVO.SupplyTaxWithoutSpc1 = selectInfo.SupplyTaxWithoutSpc1_8;
      tempVO.SupplyTaxWithoutSpc2 = selectInfo.SupplyTaxWithoutSpc2_8;
      tempVO.CostPriceStandard = selectInfo.CostPriceStandard_8;
      tempVO.CostPriceSpecial1 = selectInfo.CostPriceSpecial1_8;
      tempVO.CostPriceSpecial2 = selectInfo.CostPriceSpecial2_8;
    }

    this.kymw1102List.push(tempVO);

    viewVO.selectValue = false;
    viewVO.PCode = tempVO.PCode;
    viewVO.ItemCode = tempVO.ItemCode;
    viewVO.GuideGoodsName = tempVO.GuideGoodsName;
    viewVO.GuideStandardName = tempVO.GuideStandardName;
    viewVO.MakerName = tempVO.MakerName;
    viewVO.ClassNameKanji = tempVO.ClassNameKanji;
    viewVO.MiddleClassNameKanji = tempVO.MiddleClassNameKanji;
    viewVO.SmallClassNameKanji = tempVO.SmallClassNameKanji;

    return viewVO;
  }
}
